import { Text } from "@overmap-ai/blocks"
import type { Procedure, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { ProcedureListItem } from "./ProcedureListItem"

interface ProcedureListProps {
	procedures: Stored<Procedure>[]
	readonly?: boolean
}

export const ProcedureList = memo<ProcedureListProps>((props) => {
	const { procedures, readonly = false } = props

	return procedures.length > 0 ? (
		<div className="flex flex-col gap-2" role="list">
			{procedures.map((procedure) => (
				<ProcedureListItem key={procedure.uuid} procedure={procedure} readonly={readonly} />
			))}
		</div>
	) : (
		<Text accentColor="base" size="sm" weight="regular">
			No procedures.
		</Text>
	)
})
ProcedureList.displayName = "ProcedureList"
